module.exports = __webpack_public_path__ + "img/zixun.6076e40b.png";